<template>
  <div
    class="footer-links-section"
  >
    <a
      class="footer-term-condition-link"
      :href="settings.link_terms_of_use_href"
      target="_blank"
    >{{ settings.link_terms_of_use_label }}</a>
    <span class="footer-link-divider" />
    <a
      class="footer-private-police-link"
      :href="settings.link_privacy_policy_href"
      target="_blank"
    >{{ settings.link_privacy_policy_label }}</a>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FooterLinks",

  computed: {
    ...mapState("settings", ["settings"]),
  }
};
</script>

<style scoped>
.footer-links-section {
  margin-bottom: 16px;
}
.footer-links-section a{
  font-family: Poppins, sans-serif;
  color: #17A2B8;
  font-size: 1.5rem;
  font-weight: 300;
  text-decoration: underline;
}

#footer a {
  color: #17A2B8;
  text-decoration: underline;
}

.footer-links-section a:hover {
  color: #99c2d9;
}

.footer-term-condition-link{
  margin-right: 15px;
}

.footer-private-police-link {
  margin-left: 15px;
}

.footer-link-divider {
  /*border-right: solid 1px #567599;*/
}
</style>
